import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import App from './Components/App';
import Undefined from './Components/Undefined';
import { WorkshopTechnician,Workshop, Scheduling } from './Constants';
export default () => (
	<Router basename={process.env.PUBLIC_URL}>
		<Switch>
			<Route path="/timetracking/:ssoid" component={App} />
			<Route path="/notfound" component={Undefined} />
			<Route exact path = "/workshopTechnician"
				component={() => {
					window.location.href = WorkshopTechnician 
				}}
			/>
				<Route exact path = "/workshop"
				component={() => {
					window.location.href = Workshop 
				}}
			/>
				<Route exact path = "/scheduling"
				component={() => {
					window.location.href = Scheduling
				}}
			/>
			
		</Switch>
	</Router>
);
